

// const httpid = 'http://192.168.31.30:7030/'
// const baserurl = 'http://192.168.31.30:7030/api/'

const httpid = 'http://www.chenniao.com:8080/'
const baserurl = 'http://www.chenniao.com:8080/api/'


const NewState = {
    正常:1
}
export default {
    httpid,
    baserurl,
    NewState
}